import { UpgradeFailureTypes } from './constants';

// First match wins — order matters. More specific buckets first, broadest fallback last.
//
// This relies on Stripe's user-facing error message wording, which Stripe doesn't
// formally guarantee. Keying off `error.code` (e.g. 'card_declined', 'insufficient_funds')
// would be more durable but requires the upstream upgrade flows
// (`useMonthlyToAnnualUpgrade`, `submitMonthlyToAnnualUpgrade`, `submitMemberPowerCheckout`)
// to plumb the Stripe code through. Tracked for a follow-up.
//
// Note on the 'please try again' match: the free-user `submitMemberPowerCheckout` path
// falls back to `paymentErrors.checkout_fail_no_response` ("Unable to complete checkout.
// Please try again, or use a different payment method.") when the backend returns no
// `DisplayMessage`. In that env (silent-failure path tracked by PCK-1922's
// `checkout_fail_no_response` fallback), the cause is almost always a Stripe decline —
// we classify it as CARD_DECLINED to keep funnel parity with the monthly path which gets
// rich Stripe error info locally via `interpretStripeCardError`. Will be replaced by
// `error.code` matching once the upstream plumbing lands.
export const classifyFailureType = (error) => {
    if (!error) {
        return UpgradeFailureTypes.UNKNOWN;
    }
    const errorLower = (typeof error === 'string' ? error : '').toLowerCase();
    if (errorLower.includes('decline') || errorLower.includes('denied') || errorLower.includes('please try again')) {
        return UpgradeFailureTypes.CARD_DECLINED;
    }
    if (errorLower.includes('insufficient') || errorLower.includes('funds')) {
        return UpgradeFailureTypes.INSUFFICIENT_FUNDS;
    }
    if (errorLower.includes('processing') || errorLower.includes('network') || errorLower.includes('timeout')) {
        return UpgradeFailureTypes.PROCESSING_ERROR;
    }
    return UpgradeFailureTypes.UNKNOWN;
};
